<template>
    <div>
        <el-form v-if="showMode == 'table'" :model="vo" class="attachments-container" :class="frmViewStyle === 'DOC' ? 'docform-attach-container' : ''" :style="{ 'margin-top': showMode === 'list' ? '-1px' : '20px' }">
            <!-- 审批表单底部附件组件 -->
            <div class="el-table el-table--fit el-table--border">
                <div class="el-table__body-wrapper" :class="{ fileHovering: fileHovering }" @dragenter.capture="handleFileDragEnter($event)" @dragleave.capture="handleFileDragLeave($event)" @dragover.capture="handleFileDragOver($event)" @drop.capture="handleFileDrop($event)">
                    <table class="el-table__body" cellspacing="0" cellpadding="0" border="0">
                        <tbody>
                            <tr>
                                <td class="el-table__cell" style="text-align: left">
                                    <el-upload v-show="curTN.tnCanEdit === 1 && canUpload && !isOpenFile" ref="upload" style="float: left; padding-right: 4px" action="" :on-change="handleUploadChange" :on-error="handleUploadError" :on-exceed="handleUploadExceed" :multiple="true" :limit="limitCount" :accept="accept" :file-list="uploadAttach" :show-file-list="false" :auto-upload="false" :with-credentials="true" :disabled="isOpenFile">
                                        <el-button size="mini" style="border: 0px" @click="openFileBefore">
                                            <svg-icon icon-class="add" style="color: green" />
                                            {{ uploadBtnName }}
                                        </el-button>
                                    </el-upload>
                                    <el-button v-show="curTN.tnCanEdit === 1 && canDelete" size="mini" style="border: 0px" @click="handleUploadRemove()">
                                        <svg-icon icon-class="remove" style="color: red" />
                                        {{ deleteBtnName }}
                                    </el-button>
                                    <el-button size="mini" style="border: 0px" @click="handleFileDownload()">
                                        <svg-icon icon-class="download" :style="'color:' + lightBlue" />
                                        {{ saveasBtnName }}
                                    </el-button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <table class="el-table__body" cellspacing="0" cellpadding="0" border="0">
                        <tbody id="output_area">
                            <tr>
                                <td class="el-table__cell" style="width: 50px; text-align: center">
                                    <el-checkbox v-model="checkall" name="checkall" @change="checkAll" />
                                </td>
                                <td class="el-table__cell" style="width: 50px; text-align: center">序号</td>
                                <td class="el-table__cell">文件名</td>
                                <td class="el-table__cell" style="width: 100px; text-align: center">文件大小</td>
                                <td class="el-table__cell" style="width: 150px; text-align: center">上传时间</td>
                                <td class="el-table__cell" style="width: 80px; text-align: center">上传人</td>
                                <td v-if="(curTN.tnCanEdit === 1 && onlineEditor !== '') || showDownloadLink" class="el-table__cell" style="text-align: center" :style="operateColWidth">操作</td>
                            </tr>
                        </tbody>
                    </table>

                    <table class="el-table__body wflow-attach" cellspacing="0" cellpadding="0" border="0">
                        <tbody id="output_area" class="atach-draggable">
                            <tr v-for="(attach, index) in attachments.filter((obj) => obj.fileType === attachsType)" :key="index" :class="{ 'drag-handler': isSortAttach }">
                                <td class="el-table__cell" style="width: 50px; text-align: center; cursor: auto" align="center">
                                    <el-checkbox v-model="attach.checked" name="checkbox" @change="attachCheckedChange" />
                                </td>
                                <td class="el-table__cell" style="width: 50px; text-align: center; cursor: auto">{{ index + 1 }}</td>
                                <td class="el-table__cell" style="cursor: auto">
                                    <el-tooltip :disabled="!showOverflowTooltip" class="item" effect="dark" :content="attach.fileName" placement="bottom-start">
                                        <el-link type="primary" class="attach-name" @click="handleUploadPreview(attach)">{{ attach.fileName }}</el-link>
                                    </el-tooltip>
                                </td>
                                <td class="el-table__cell" style="width: 100px; text-align: center" :title="isSortAttach ? '按下鼠标拖可动排序' : ''">
                                    {{ attach.fileSize }}
                                </td>

                                <template v-if="attach.id">
                                    <td class="el-table__cell" style="width: 150px; text-align: center" :title="isSortAttach ? '按下鼠标拖可动排序' : ''">
                                        {{ attach.uploadTime }}
                                    </td>
                                    <td class="el-table__cell" style="width: 80px" :title="isSortAttach ? '按下鼠标拖可动排序' : ''">
                                        <el-tooltip :disabled="attach.uploadBy.length <= 5" class="item" effect="dark" :content="attach.uploadBy" placement="top">
                                            <div style="width: 100%; text-align: center; overflow: hidden; text-overflow: ellipsis; white-space: nowrap">
                                                {{ attach.uploadBy }}
                                            </div>
                                        </el-tooltip>
                                    </td>

                                    <td v-if="(curTN.tnCanEdit === 1 && onlineEditor !== '') || showDownloadLink" class="el-table__cell" :style="operateColWidth" style="text-align: center; cursor: auto">
                                        <el-link v-if="curTN.tnCanEdit === 1 && onlineEditor !== ''" :title="attach.canModify ? '编辑' : ''" :disabled="!attach.canModify" @click="handleOpenEditor(attach)"><i :class="'el-icon-edit'" style="font-size: 16px" /></el-link>
                                        <template v-if="curTN.tnCanEdit === 1 && canDelete">
                                            &nbsp;
                                            <el-link :title="'删除'" type="danger" @click="handleUploadRemove(attach)"><i :class="'el-icon-close'" style="color: #ff0000; font-size: 16px" /></el-link>
                                        </template>
                                        <template v-if="showDownloadLink">
                                            &nbsp;
                                            <el-link :title="'下载'" @click="handleOneFileDownload(attach)"><i :class="'el-icon-download'" style="font-size: 16px" /></el-link>
                                        </template>
                                    </td>
                                </template>

                                <td v-else class="el-table__cell" style="width: 330px" colspan="3">
                                    <el-progress v-if="!attach.file.message && attach.file.progress > 0" :text-inside="true" :stroke-width="20" :percentage="attach.file.progress" status="success" />
                                    <div v-else-if="attach.file.message && attach.file.progress === 0" style="width: 100%">待上传</div>
                                    <div v-if="attach.file.message" style="color: #ff0000; width: 100%">
                                        {{ attach.file.message }}
                                    </div>
                                </td>
                            </tr>
                            <tr v-if="!hasAttachment">
                                <td class="el-table__cell" style="width: 50px; text-align: center"><input type="checkbox" disabled="true" /></td>
                                <td class="el-table__cell" style="width: 50px; text-align: center" />
                                <td class="el-table__cell" />
                                <td class="el-table__cell" style="width: 100px; text-align: center" />
                                <td class="el-table__cell" style="width: 150px; text-align: center" />
                                <td class="el-table__cell" style="width: 80px; text-align: center" />
                                <td v-if="(curTN.tnCanEdit === 1 && onlineEditor !== '') || showDownloadLink" class="el-table__cell" style="text-align: center" :style="operateColWidth" />
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </el-form>
        <div v-else-if="showMode === 'sidebar'" class="attachment-sidebar">
            <!-- 审批表单正文侧边栏附件 -->
            <div class="sidebar-area">
                <div class="sidebar-area-title">
                    <el-button size="mini" type="primary" />
                    <div>附件</div>
                    <el-upload v-show="curTN.tnCanEdit === 1 && canUpload && !isOpenFile" ref="upload" style="float: right" action="" :on-change="handleUploadChange" :on-error="handleUploadError" :on-exceed="handleUploadExceed" :multiple="limitCount > 1" :limit="limitCount" :accept="accept" :file-list="uploadAttach" :show-file-list="false" :auto-upload="false" :with-credentials="true">
                        <el-link slot="trigger" :underline="false" @click="openFileBefore">
                            <svg-icon icon-class="add" style="color: green; padding-right: 4px" />
                            添加
                        </el-link>
                    </el-upload>
                </div>
                <div class="sidebar-area-content">
                    <el-row v-for="(attach, index) in attachments.filter((obj) => obj.fileType === attachsType)" :key="index" class="attach-row" align="middle">
                        <el-col span="24" class="flex-row" style="overflow: hidden">
                            <div style="font-size: 16px; margin-right: 5px; display: inline-block; line-height: 22px">
                                <img :src="imgUrl(attach)" style="width: 12px" alt="" />
                            </div>
                            <div v-if="attach.id" style="width: calc(100% - 22px); display: inline-block">
                                <el-link type="primary" :underline="false" class="attach-name" :title="attach.fileName" @click="handleUploadPreview(attach)">{{ attach.fileName }}</el-link>
                                <div style="float: left; width: 100%; display: inline-block">
                                    <span style="color: #a7a7a7; padding-right: 5px">{{ attach.uploadTime }}</span>
                                    <span style="color: #a7a7a7; padding-left: 5px; padding-right: 5px">{{ attach.fileSize }}</span>
                                    <el-link v-show="curTN.tnCanEdit === 1 && canDelete" :underline="false" style="float: right; margin-left: 5px" @click="handleUploadRemove(attach)">
                                        <el-tooltip content="删除"><svg-icon icon-class="remove" style="color: red" /></el-tooltip>
                                    </el-link>
                                    <el-link v-show="curTN.tnCanEdit === 1 && canReupload" :underline="false" style="float: right; margin-left: 5px" @click="handleReupload(attach)">
                                        <el-tooltip content="重新上传"><i :class="'el-icon-upload2'" style="font-size: 18px; margin-top: 1px" /></el-tooltip>
                                    </el-link>
                                    <el-link v-if="curTN.tnCanEdit === 1 && onlineEditor !== ''" :underline="false" :disabled="!attach.canModify" style="float: right" @click="handleOpenEditor(attach)">
                                        <el-tooltip :disabled="!attach.canModify" content="编辑"><i :class="'el-icon-edit'" style="font-size: 16px" /></el-tooltip>
                                    </el-link>
                                </div>
                            </div>
                            <div v-else style="width: calc(100% - 22px); display: inline-block">
                                <div class="attach-name" :title="attach.fileName">{{ attach.fileName }}</div>
                                <div style="float: left; width: 100%; display: inline-block">
                                    <div style="line-height: 21px; width: 100%">
                                        <span style="color: #a7a7a7; padding-right: 5px">{{ attach.uploadTime }}</span>
                                        <span style="color: #a7a7a7; padding-left: 5px; padding-right: 5px">{{ attach.fileSize }}</span>
                                        <el-link v-show="attach.file.progress == 0 && canReupload" :underline="false" style="float: right" @click="handleReupload(attach)">
                                            <el-tooltip content="重新上传"><i :class="'el-icon-upload2'" style="font-size: 18px; margin-top: 1px; margin-left: 5px" /></el-tooltip>
                                        </el-link>
                                        <el-link v-show="attach.file.progress == 0" :underline="false" style="float: right" @click="handleUploadRemove(attach)">
                                            <el-tooltip content="删除"><svg-icon icon-class="remove" style="color: red" /></el-tooltip>
                                        </el-link>
                                    </div>
                                    <el-progress v-if="!attach.file.message && attach.file.progress > 0" :color="'#409eff'" style="margin: 0px auto" :percentage="attach.file.progress" :status="attach.file.progress == 100 ? 'success' : ''" />
                                    <div v-if="attach.file.message" class="attach-name" style="color: #ff0000; width: 100%; overflow: hidden">
                                        <span>{{ attach.file.message }}</span>
                                    </div>
                                </div>
                            </div>
                        </el-col>
                    </el-row>
                    <el-row v-if="attachments.filter((obj) => obj.fileType === attachsType).length == 0" class="no-attachments">
                        <el-col span="24" style="padding: 15px 0 15px 0">
                            {{ emptyMessage ? emptyMessage : '暂无附件' }}
                        </el-col>
                    </el-row>
                </div>
            </div>
        </div>
        <div v-else-if="showMode === 'list' && isDrag">
            <template />
            <el-upload v-if="curTN.tnCanEdit === 1 && canUpload && !isOpenFile" ref="upload" drag class="drag-upload" action="" :on-change="handleUploadChange" :on-error="handleUploadError" :on-exceed="handleUploadExceed" :multiple="limitCount > 1" :limit="limitCount" :file-list="uploadAttach" :show-file-list="false" :auto-upload="false" :with-credentials="true">
                <div class="drag-upload-box">
                    <svg-icon icon-class="drag-icon" />
                    <span style="color: #666666">上传文件，请</span>
                    <span style="color: #1a82e3; margin-left: 5px">点击上传</span>
                </div>
            </el-upload>
            <div v-if="attachments.filter((obj) => obj.fileType === attachsType).length > 0" class="upload-view" :style="{ 'padding-top': curTN.tnCanEdit === 1 && canUpload && !isOpenFile ? '10px' : '' }">
                <div v-for="(attach, index) in attachments.filter((obj) => obj.fileType === attachsType)" :key="index" class="upload-box" :gutter="0">
                    <div class="upload-box-left">
                        <div class="upload-label">
                            <div class="label-l">
                                <img :src="imgUrl(attach)" alt="" />
                            </div>
                            <div class="label-r">
                                {{ attach.fileName }}
                            </div>
                        </div>
                    </div>
                    <div class="upload-box-right">
                        <div class="up-text">{{ attach.uploadTime }}</div>
                        <div class="up-person">
                            <span class="up-text upload-name">{{ attach.uploadBy }}</span>
                            <span class="up-text">{{ attach.fileSize }}</span>
                        </div>
                        <div class="up-btn">
                            <svg-icon v-show="attach.uploadTime !== '待上传'" icon-class="download" class="down" @click="handleOneFileDownload(attach)" />
                            <i v-show="curTN.tnCanEdit === 1 && canDelete" class="el-icon-delete" style="font-size: 16px; color: #999999" @click="handleUploadRemove(attach)" />
                        </div>
                    </div>
                </div>
            </div>
            <el-row v-if="attachments.filter((obj) => obj.fileType === attachsType).length == 0 && curTN.tnCanEdit === 0" class="no-attachments">
                <el-col span="24" style="padding: 15px 0 15px 0">
                    {{ emptyMessage ? emptyMessage : '暂无附件' }}
                </el-col>
            </el-row>
        </div>
        <div v-else class="tb-row-attach-container">
            <!-- 基本表单表格行附件 -->
            <el-upload v-if="(curTN.tnCanEdit === 1 && canUpload && !isOpenFile) || attachments.filter((obj) => obj.fileType === attachsType).length > 1" ref="upload" style="float: left; padding-right: 4px; display: contents" action="" :on-change="handleUploadChange" :on-error="handleUploadError" :on-exceed="handleUploadExceed" :multiple="limitCount > 1" :limit="limitCount" :accept="accept" :file-list="uploadAttach" :show-file-list="false" :auto-upload="false" :with-credentials="true">
                <el-button v-if="curTN.tnCanEdit === 1 && canUpload && !isOpenFile" id="btnUpload" slot="trigger" size="mini" @click="openFileBefore">
                    <svg-icon icon-class="add" style="color: green" />
                    {{ emptyMessage ? '添加' : '添加附件' }}
                </el-button>
                <el-button v-if="attachments.filter((obj) => obj.fileType === attachsType).length > 1 && curTN.tnCanEdit === 1" id="btnUpload" slot="trigger" size="mini" @click.stop="handleUploadRemove()">
                    <svg-icon icon-class="wjzx_delcopy" />
                    {{ deleteBtnName }}
                </el-button>
                <el-button v-if="attachments.filter((obj) => obj.fileType === attachsType).length > 1" id="btnUpload" slot="trigger" size="mini" @click.stop="handleFileDownload()">
                    <svg-icon icon-class="wjzx_downcopy" />
                    {{ saveasBtnName }}
                </el-button>
            </el-upload>

            <el-row v-for="(attach, index) in attachments.filter((obj) => obj.fileType === attachsType)" :key="index" class="attach-row" align="middle">
                <el-col span="24" style="overflow: hidden; display: flex">
                    <el-checkbox v-if="attachments.filter((obj) => obj.fileType === attachsType).length > 1" v-model="attach.checked" name="checkbox" style="margin-right: 5px" @change="attachCheckedChange" />
                    <div style="font-size: 16px; margin-right: 5px" :style="{ 'line-height': !attach.id ? '22px' : '' }">
                        <img :src="imgUrl(attach)" style="width: 12px" alt="" />
                    </div>
                    <div v-if="attach.id" style="width: calc(100% - 22px); float: left">
                        <div style="float: left; width: calc(100% - 150px)">
                            <el-link type="primary" class="attach-name" :title="attach.fileName" style="margin-top: -3px; max-width: calc(100% - 100px)" @click="handleUploadPreview(attach)">{{ attach.fileName }}</el-link>
                            <span style="color: #a7a7a7; padding-left: 5px; padding-right: 5px">{{ attach.fileSize }}</span>
                            <el-link v-if="curTN.tnCanEdit === 1 && onlineEditor !== ''" style="margin-right: 5px" :underline="false" :disabled="!attach.canModify" @click="handleOpenEditor(attach)">
                                <el-tooltip :disabled="!attach.canModify" content="编辑"><i :class="'el-icon-edit'" style="font-size: 16px" /></el-tooltip>
                            </el-link>
                            <el-link v-show="curTN.tnCanEdit === 1 && canReupload && !attach.selectType == 1" style="margin-right: 5px" :underline="false" @click="handleReupload(attach)">
                                <el-tooltip content="重新上传"><i :class="'el-icon-upload2'" style="font-size: 18px; margin-top: 1px; margin-left: 5px" /></el-tooltip>
                            </el-link>
                            <el-link v-show="curTN.tnCanEdit === 1 && canDelete && !attach.selectType == 1" :underline="false" @click="handleUploadRemove(attach)">
                                <el-tooltip content="删除"><svg-icon icon-class="remove" style="color: red" /></el-tooltip>
                            </el-link>
                            <el-link :title="'下载'" @click="handleOneFileDownload(attach)"><i :class="'el-icon-download'" style="font-size: 16px; color: #409eff" /></el-link>
                        </div>
                        <span style="color: #a7a7a7; float: right">{{ attach.uploadTime }}</span>
                    </div>
                    <div v-else style="width: calc(100% - 22px); float: left">
                        <div style="line-height: 21px; width: 100%">
                            <div class="attach-name" style="float: left; max-width: calc(100% - 113px)">
                                <span style="display: block">{{ attach.fileName }}</span>
                            </div>
                            <span style="color: #a7a7a7; padding-left: 5px; padding-right: 5px">{{ attach.fileSize }}</span>
                            <el-link v-show="attach.file.progress == 0 && canReupload" :underline="false" @click="handleReupload(attach)">
                                <el-tooltip content="重新上传"><i :class="'el-icon-upload2'" style="font-size: 18px; margin-top: 1px; margin-left: 5px" /></el-tooltip>
                            </el-link>
                            <el-link v-show="attach.file.progress == 0" :underline="false" style="margin-top: -5px" @click="handleUploadRemove(attach)">
                                <el-tooltip content="删除"><svg-icon icon-class="remove" style="color: red" /></el-tooltip>
                            </el-link>
                        </div>
                        <el-progress v-if="!attach.file.message && attach.file.progress > 0" :color="'#409eff'" style="margin: 0px auto" :percentage="attach.file.progress" :status="attach.file.progress == 100 ? 'success' : ''" />
                        <div v-if="attach.file.message" class="attach-name" style="color: #ff0000; width: 100%; overflow: hidden">
                            <span>{{ attach.file.message }}</span>
                        </div>
                    </div>
                </el-col>
            </el-row>
            <el-row v-if="attachments.filter((obj) => obj.fileType === attachsType).length == 0" class="no-attachments">
                <el-col span="24" style="padding: 15px 0 15px 0">
                    {{ emptyMessage ? emptyMessage : '暂无附件' }}
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
const imgType = ['png', 'jpg', 'gif', 'jpeg', 'webp', 'ico', 'jfif', 'bmp']

import variables from '@/wapp/common/styles/variables.module.scss'
import { mapGetters } from 'vuex'
import { formatFileSize } from '@/global/utils/index'
import Sortable from 'sortablejs'
let _this = null
export default {
    name: 'XmFujian',
    components: {},
    props: {
        vo: {
            type: Object,
            default: function () {
                return {}
            }
        },
        curTN: {
            type: Object,
            default: function () {
                return {}
            }
        },
        flBodyfile: {
            type: Object,
            default: function () {
                return { file: { name: '' } }
            }
        },
        attachments: {
            type: Array,
            default: function () {
                return []
            }
        }, // 已上传文件
        accept: { type: String, default: '*.*' },
        autoUpload: { type: Boolean, default: false }, // 是否开启自动上传
        batchSaveNamefield: { type: String, default: '' }, // 批量下载时另存为文件名称
        wfAttachUrl: { type: String, default: '' },
        emptyMessage: { type: String, default: '' }, // 无附件提示
        onlineFile: { type: String, default: '' }, // doc转pdf在线预览文件格式
        viewer: { type: String, default: 'pdfjs' }, // 在线预览文件方式
        viewerUrlParams: { type: String, default: '' }, // 在线预览额外参数添加
        canEdit: { type: Number, default: null },
        limitCount: { type: Number, default: 100 },
        isRequired: { type: Number, default: 0 }, // 是否至少上传一个
        attachsType: { type: String, default: 'ATTACH' },
        isSortAttach: { type: Boolean, default: false }, // 是否可以进行附件排序
        uploadBtnName: { type: String, default: '添加文件' },
        saveasBtnName: { type: String, default: '另存文件' },
        deleteBtnName: { type: String, default: '删除文件' },
        attachEdit: { type: Object, default: null },
        onlineEditor: { type: String, default: '' }, // 在线编辑器，默认为空，支持wpsh5、yzh5、ech5
        waterMark: { type: Boolean, default: false },
        markContent: { type: String, default: '' },
        sameNameBodyfile: { type: Boolean, default: true }, // 是否与正文文件同名
        showDownloadLink: { type: Boolean, default: false }, // 是否提供列操作"下载"链接
        showOverflowTooltip: { type: Boolean, default: true }, // 当列内容过长被隐藏时显示 tooltip
        onAttachPreviewClick: { type: Function, default: null },
        showMode: { type: String, default: '' }, // 附件控件显示模式，table:表格模式，list：列表模式
        isDrag: { type: Number, default: 0 } // 是否启用拖拽上传
    },
    data() {
        return {
            lightBlue: variables.lightBlue,
            uploadAttach: [], // 选择待上传文件
            checkall: false,
            fileHovering: false,
            isOpenFile: false,
            canUpload: true,
            canDelete: true,
            sortable: null,
            sortDrags: false, // 是否是附件内部拖拽排序
            operateColWidth: 'width:100px', // 操作列宽度
            frmViewStyle: 'WEB'
        }
    },
    computed: {
        hasAttachment() {
            const hasAttachment = this.attachments.some((attach) => {
                return attach.fileType === this.attachsType
            })

            return hasAttachment
        },
        canReupload() {
            const attachCount = this.attachments.filter((obj) => obj.fileType === this.attachsType).length
            if (attachCount >= this.limitCount) {
                return true
            } else {
                return false
            }
        },
        ...mapGetters(['loginUser'])
    },
    watch: {
        uploadAttach(val) {
            const filelength = this.attachments.filter((obj) => obj.fileType === this.attachsType).length
            const attachLength = this.attachments.filter((obj) => obj.fileType === this.attachsType && obj.id).length
            if (filelength > this.limitCount) {
                if (this.attachments.filter((obj) => obj.fileType === this.attachsType && obj.id).length > 0) {
                    this.$message.warning(`当前限制上传 ${this.limitCount} 个文件，已上传了 ${attachLength} 个文件，本次选择了 ${val.length} 个文件，已超出 ${filelength - this.limitCount} 个文件`)
                } else {
                    this.$message.warning(`当前限制上传 ${this.limitCount} 个文件，本次选择了 ${val.length} 个文件，共有 ${filelength} 个文件`)
                }
                this.uploadAttach = []
                this.attachments.splice(-1, val.length)
                this.isOpenFile = false
                return
            }
        },
        attachments: {
            handler(val) {
                if (val.filter((obj) => obj.fileType === this.attachsType).length >= this.limitCount) {
                    this.isOpenFile = true
                } else {
                    this.isOpenFile = false
                }
                const wfAttachUrl = this.wfAttachUrl

                if (this.attachments.length > 0) {
                    const imgViewList = []
                    let imgIndex = 0

                    this.attachments.forEach((item) => {
                        if (item.fileType === this.attachsType && window.openImgView && item.id && imgType.indexOf(item.fileName.substr(item.fileName.lastIndexOf('.') + 1).toLowerCase()) > -1) {
                            item.downLoadPath = process.env.VUE_APP_BASE_API + '/' + wfAttachUrl + '/downloadById?inline=true&attachIds=' + item.id + '&topdf=false&httpPort=' + location.port
                            item.index = imgIndex
                            imgViewList.push(item)
                            imgIndex++
                        }

                        let extName = ''
                        if (item.fileName.indexOf('.') !== -1) {
                            extName = item.fileName.substring(item.fileName.lastIndexOf('.')).toLowerCase()
                            if (extName !== '' && (this.onlineFile + ',').indexOf(extName + ',') !== -1) {
                                item.canModify = true
                            }
                        }
                    })

                    if (window.openImgView) {
                        sessionStorage.setItem('IMG_VIEW_LIST_' + this.vo.id, JSON.stringify(imgViewList))
                    }
                }
            },
            immediate: true
        },
        canEdit(val) {
            this.$set(this.curTN, 'tnCanEdit', val)
        },
        curTN: {
            handler(val) {
                this.setCurTN()
            },
            deep: true
        }
    },
    created() {
        _this = this
        if (!this.limitCount) this.limitCount = 100
    },
    beforeDestroy() {},
    updated() {
        this.setCurTN()
    },
    mounted() {
        this.setCurTN()
    },
    methods: {
        bindDraggable() {
            const el = document.querySelector('.attachments-container .wflow-attach tbody')
            if (el !== null) {
                this.sortable = Sortable.create(el, {
                    handle: '.drag-handler',
                    dragClass: 'sortable-drag',
                    setData: function (dataTransfer) {
                        dataTransfer.setData('Text', '')
                    },
                    onChoose: () => {
                        _this.sortDrags = true
                    },
                    onEnd: (evt) => {
                        const attachs = _this.attachments.filter((attach) => {
                            if (attach.fileType === this.attachsType) return true
                        })
                        const attacrow = attachs[evt.oldIndex]
                        if (!attacrow) return

                        attachs.splice(evt.oldIndex, 1)
                        attachs.splice(evt.newIndex, 0, attacrow)

                        _this.attachments.forEach((attach) => {
                            if (attach.fileType !== this.attachsType) {
                                attachs.push(attach)
                            }
                        })

                        const sortedAttachs = attachs.filter((attach) => {
                            if (attach.fileType === this.attachsType) return true
                        })

                        if (this.$vnode.context && this.$vnode.context.wfInstance) {
                            const parent = this.$vnode.context
                            parent.wfInstance.passenger = parent.wfInstance.passenger || {}
                            parent.$set(parent.wfInstance.passenger, 'sortedAttachs', sortedAttachs)
                        }

                        _this.sortDrags = false
                        _this.attachments.splice(0, _this.attachments.length)
                        _this.$nextTick(() => {
                            _this.attachments.push(...attachs)
                        })
                    }
                })
            }
        },
        setCurTN() {
            this.frmViewStyle = this.$vnode.context.frmViewStyle || this.frmViewStyle

            if (this.curTN.tnCanEdit !== undefined) {
                // 流程表单
                this.showMode = this.showMode || 'table'

                const tnAttachEdit = (this.curTN.tnAttachEdit || '').split(',')
                if (tnAttachEdit.length === 3) {
                    this.canUpload = tnAttachEdit[0] === '1'
                    this.canDelete = tnAttachEdit[2] === '1'
                }

                setTimeout(() => {
                    this.isSortAttach = this.isSortAttach && this.curTN.tnCanEdit === 1
                    if (this.isSortAttach && this.hasAttachment) {
                        this.bindDraggable()
                    }
                }, 200)
            } else if (this.curTN.tnCanEdit === undefined) {
                // 非流程表单
                this.showMode = this.showMode || 'list'

                if (this.attachEdit !== null) {
                    if (this.attachEdit.canUpload !== '' && this.attachEdit.canUpload !== null && this.attachEdit.canUpload !== undefined) this.canUpload = this.attachEdit.canUpload
                    if (this.attachEdit.canDelete !== '' && this.attachEdit.canDelete !== null && this.attachEdit.canDelete !== undefined) this.canDelete = this.attachEdit.canDelete
                }

                this.curTN.tnCanEdit = this.canEdit || this.$vnode.context.canEdit
                this.$vnode.context.$attachments = this
            }
            const attachContainer = document.querySelector('.attachments-container')
            if (attachContainer !== null) {
                if (this.showMode === 'list') {
                    attachContainer.style.marginTop = '-1px'
                    attachContainer.querySelector('.el-table--border').style.zIndex = 2
                } else {
                    attachContainer.style.marginTop = '20px'
                }
            }

            if ((this.curTN.tnCanEdit !== 1 || this.onlineEditor === '') && this.showDownloadLink) {
                this.operateColWidth = 'width:80px;'
            } else {
                this.operateColWidth = 'width:100px;'
            }

            // 添加到basicform组件管理的附件组件数组中，实现一个表单多个附件组件可正常上传功能
            const refsAttachments = this.$vnode.context.refsAttachments || this.$vnode.context.$parent.refsAttachments || this.$vnode.context.$parent.$vnode.context.refsAttachments
            if (refsAttachments) {
                const pushed = refsAttachments.filter((a) => {
                    if (a.attachsType === this.attachsType) return true
                })
                if (pushed.length === 0) {
                    refsAttachments.push(this)
                }
            }

            if (this.wfAttachUrl === '') {
                if (this.$vnode.context.moduleInfo) {
                    this.wfAttachUrl = this.$vnode.context.moduleInfo.insertUrl.split('/insert')[0]
                } else if (this.$vnode.context.$vnode.context.wfAttachUrl) {
                    this.wfAttachUrl = this.$vnode.context.$vnode.context.wfAttachUrl
                } else if (this.$vnode.context.wfParams) {
                    this.wfAttachUrl = this.$vnode.context.wfParams.wfEngineUrl
                } else if (this.$vnode.context.$vnode.context.wfParams) {
                    this.wfAttachUrl = this.$vnode.context.$vnode.context.wfParams.wfEngineUrl
                }
            }
        },
        // 文件进入事件
        handleFileDragEnter(e) {
            if (_this.sortDrags) return
            e.stopPropagation()
            e.preventDefault()
            this.fileHovering = true
        },
        // 文件离开事件
        handleFileDragLeave(e) {
            if (_this.sortDrags) return
            e.stopPropagation()
            e.preventDefault()
            this.fileHovering = false
        },
        // 文件拖拽完成效果
        handleFileDragOver(e) {
            if (_this.sortDrags) return
            e.stopPropagation()
            e.preventDefault()
            e.dataTransfer.dropEffect = 'copy'
            this.fileHovering = true
        },
        openFileBefore() {
            if (this.isOpenFile) {
                this.$message.warning(`当前限制上传 ${this.limitCount} 个文件，不允许在添加新文件`)
            }
        },
        // 文件拖拽到页面后处理方式
        handleFileDrop(e) {
            if (_this.sortDrags) return
            e.stopPropagation()
            e.preventDefault()
            this.fileHovering = false
            const files = e.dataTransfer.files
            for (var j = 0; j < this.attachments.length; j++) {
                for (let i = 0; i < files.length; i++) {
                    const file = files[i]
                    if (file.name === this.attachments[j].fileName && (this.attachments[j].fileType === this.attachsType || (!this.sameNameBodyfile && this.attachments[j].fileType === 'BODY'))) {
                        this.$message.error('文件“' + file.name + '”已存在，不允许上传命名文件。')
                        return
                    }
                }
            }

            for (const fileItem of files) {
                this.attachments.push({
                    fileName: fileItem.name,
                    fileSize: formatFileSize(fileItem.size),
                    fileType: this.attachsType,
                    uploadBy: this.loginUser.personName,
                    uploadTime: '待上传',
                    file: { raw: fileItem, name: fileItem.name, size: fileItem.size },
                    checked: false,
                    progress: 0
                })
            }
        },
        checkAll() {
            this.attachments.forEach((attach) => {
                if (attach.fileType === this.attachsType) {
                    attach.checked = this.checkall
                }
            })
        },
        attachCheckedChange() {
            let checkedAll = true
            this.attachments.forEach((attach) => {
                if (!attach.checked && attach.fileType === this.attachsType) {
                    checkedAll = false
                }
            })
            this.checkall = checkedAll
            this.$forceUpdate()
        },
        handleUploadPreview(attach) {
            if (attach.id === undefined) return
            if (this.onAttachPreviewClick) {
                // 自定义附件下载预览事件
                this.onAttachPreviewClick(attach)
                return
            }

            let extName = ''
            let topdf = false
            if (attach.fileName.indexOf('.') !== -1) {
                extName = attach.fileName.substring(attach.fileName.lastIndexOf('.')).toLowerCase()
                if (extName !== '.pdf' && extName !== '.pdfx' && (this.onlineFile + ',').indexOf(extName + ',') !== -1) {
                    topdf = true
                }
            }
            if (this.viewer.indexOf('dcs=') === 0 && (topdf || extName === '.pdf' || extName === '.pdfx' || extName === '.ofd')) {
                this.$http({
                    method: 'GET',
                    url: 'base/user/getSessionId'
                }).then((res) => {
                    if (res.code === 'success') {
                        const tSessionId = res.body.tSessionId
                        const hostname = location.href.split('#')[0]
                        let downUrl = hostname.substring(0, hostname.length - 1) + process.env.VUE_APP_BASE_API + '/' + this.wfAttachUrl + '/downloadById?attachIds=' + attach.id + '&httpPort=' + location.port + '&tSessionId=' + tSessionId

                        let convertType = '0'
                        if (extName === '.pdf') {
                            convertType = '20'
                        } else if (extName === '.ofd') {
                            convertType = '21'
                        }

                        downUrl = this.viewer.split('=')[1] + '/composite/httpfile?convertType=' + convertType + '&fileUrl=' + encodeURIComponent(downUrl + (this.waterMark ? '&waterMark=' + this.waterMark + '&markContent=' + this.markContent : ''))
                        if (this.viewerUrlParams !== '' && this.viewerUrlParams !== null && this.viewerUrlParams !== undefined) {
                            downUrl += this.viewerUrlParams
                        }
                        this.$bus.emit('showDoingDialog', '正在生成在线预览文件，请稍候...')
                        $.post(
                            downUrl,
                            {},
                            (res) => {
                                this.$bus.emit('closeDoingDialog')
                                if (res.errorcode === 0) {
                                    window.open(res.data.viewUrl)
                                } else {
                                    this.$alert(res.message, '操作提示', { type: 'error' })
                                }
                            },
                            'json'
                        )
                    }
                })
            } else if (this.viewer === 'wpsjs') {
                this.$bus.emit('btnPreviewAttachClick', attach, this.onlineEditor)
            } else {
                if (imgType.indexOf(extName.substring(1)) > -1 && window.openImgView) {
                    sessionStorage.setItem('IMG_INDEX_' + this.vo.id, attach.index)
                    window.open('#/imgView?wfAttachUrl=' + this.wfAttachUrl + '&busiDataId=' + this.vo.id)
                    return
                }
                let downUrl = process.env.VUE_APP_BASE_API
                downUrl += this.wfAttachUrl.substring(0, 1) === '/' ? this.wfAttachUrl : '/' + this.wfAttachUrl
                downUrl += '/downloadById?inline=true&attachIds=' + attach.id + '&topdf=' + topdf
                downUrl += this.waterMark ? '&waterMark=' + this.waterMark + '&markContent=' + this.markContent : ''
                downUrl += '&httpPort=' + location.port
                if (extName === '.ofd') {
                    // ofd 预览
                    downUrl += '&fileName=' + attach.fileName
                    window.open('./plugins/OfdJs/view.html?file=' + encodeURIComponent(downUrl))
                } else {
                    window.open(downUrl)
                }
            }
        },
        handleUploadExceed(files, fileList) {
            console.log('handleUploadExceed' + files)
            // this.$message.warning(`当前限制选择 ${this.limitCount} 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`)
            const attachLength = this.attachments.filter((obj) => obj.fileType === this.attachsType && obj.id).length
            const filelength = attachLength + files.length + fileList.length
            if (this.attachments.filter((obj) => obj.fileType === this.attachsType && obj.id).length > 0) {
                this.$message.warning(`当前限制上传 ${this.limitCount} 个文件，已上传了 ${attachLength} 个文件，本次选择了 ${files.length} 个文件，已超出 ${filelength - this.limitCount} 个文件`)
            } else {
                this.$message.warning(`当前限制上传 ${this.limitCount} 个文件，本次选择了 ${files.length} 个文件，共选择了 ${filelength} 个文件，已超出 ${filelength - this.limitCount} 个文件`)
            }
        },
        handleReupload(file, fileList) {
            let attachIds = ''
            for (var i = 0; i < this.attachments.length; i++) {
                if (this.attachments[i].forward && file.id === this.attachments[i].id) {
                    this.attachments.splice(i--, 1)
                } else if (file.file !== undefined && file.file === this.attachments[i].file) {
                    for (let j = 0; j < this.uploadAttach.length; j++) {
                        if (this.uploadAttach[j].name === this.attachments[i].fileName) {
                            this.uploadAttach.splice(j--, 1)
                        }
                    }
                    this.attachments.splice(i--, 1)
                } else if (file.id !== undefined && file.id === this.attachments[i].id) {
                    if (attachIds !== '') {
                        attachIds += ',' + this.attachments[i].id
                    } else {
                        attachIds = this.attachments[i].id
                    }
                }
            }
            new Promise((resole) => {
                if (attachIds !== '') {
                    let deleteUrl = this.wfAttachUrl + '/delete'
                    if (this.$vnode.context.wfInstance === undefined || this.$vnode.context.wfInstance.id === undefined) deleteUrl = this.wfAttachUrl + '/deleteAttach' // 非流程表单

                    this.$confirm(`您是否确认删除并重新上传？`, '确认操作', { type: 'warning' })
                        .then(() => {
                            this.$bus.emit('showDoingDialog')

                            this.$http({
                                method: 'DELETE',
                                contentType: 'application/x-www-form-urlencoded',
                                params: { attachIds: attachIds },
                                url: deleteUrl
                            }).then((res) => {
                                this.$bus.emit('closeDoingDialog')
                                var _this = this
                                if (res.code === 'success') {
                                    for (let i = 0; i < this.attachments.length; i++) {
                                        if (file !== undefined) {
                                            if (file.id === this.attachments[i].id) {
                                                this.attachments.splice(i--, 1)
                                            }
                                        } else if (this.attachments[i].checked) {
                                            this.attachments.splice(i--, 1)
                                        }
                                        if (_this.attachments[i]) _this.attachments[i].checked = false
                                    }

                                    resole(true)
                                } else {
                                    resole(false)
                                    this.$alert(res.message, '操作提示', { type: 'error' })
                                }
                            })
                        })
                        .catch(() => {
                            resole(false)
                        })
                } else {
                    resole(true)
                }
            }).then((res) => {
                if (res) {
                    if (this.attachments.filter((obj) => obj.fileType === this.attachsType).length >= this.limitCount) {
                        this.isOpenFile = true
                    } else {
                        this.isOpenFile = false
                    }
                    document.querySelector('#btnUpload').click()
                }
            })
        },
        handleUploadRemove(file, fileList) {
            let attachIds = ''
            for (var i = 0; i < this.attachments.length; i++) {
                if (file !== undefined) {
                    if (this.attachments[i].forward && file.id === this.attachments[i].id) {
                        this.attachments.splice(i--, 1)
                    } else if (file.file !== undefined && file.file === this.attachments[i].file) {
                        for (let j = 0; j < this.uploadAttach.length; j++) {
                            if (this.uploadAttach[j].name === this.attachments[i].fileName) {
                                this.uploadAttach.splice(j--, 1)
                            }
                        }
                        this.$emit('change', file, 0)
                        this.attachments.splice(i--, 1)
                    } else if (file.id !== undefined && file.id === this.attachments[i].id) {
                        if (attachIds !== '') {
                            attachIds += ',' + this.attachments[i].id
                        } else {
                            attachIds = this.attachments[i].id
                        }
                    }
                } else if (this.attachments[i].checked) {
                    if (this.attachments[i].file !== undefined) {
                        for (let j = 0; j < this.uploadAttach.length; j++) {
                            if (this.uploadAttach[j].name === this.attachments[i].fileName) {
                                this.uploadAttach.splice(j--, 1)
                            }
                        }
                        this.$emit('change', file, 0)
                        this.attachments.splice(i--, 1)
                    } else if (this.attachments[i].forward) {
                        this.attachments.splice(i--, 1)
                    } else if (attachIds !== '') {
                        attachIds += ',' + this.attachments[i].id
                    } else {
                        attachIds = this.attachments[i].id
                    }
                }
            }

            if (attachIds !== '') {
                let deleteUrl = this.wfAttachUrl + '/delete'
                if (this.$vnode.context.wfInstance === undefined || this.$vnode.context.wfInstance.id === undefined) deleteUrl = this.wfAttachUrl + '/deleteAttach' // 非流程表单

                this.$confirm(`您是否确认删除选择的附件？`, '确认操作', { type: 'warning' }).then(() => {
                    this.$bus.emit('showDoingDialog')

                    this.$http({
                        method: 'DELETE',
                        contentType: 'application/x-www-form-urlencoded',
                        params: { attachIds: attachIds },
                        url: deleteUrl
                    }).then((res) => {
                        this.$bus.emit('closeDoingDialog')
                        var _this = this
                        if (res.code === 'success') {
                            this.$emit('change', file, 0)
                            for (let i = 0; i < this.attachments.length; i++) {
                                if (file !== undefined) {
                                    if (file.id === this.attachments[i].id) {
                                        this.attachments.splice(i--, 1)
                                    }
                                } else if (this.attachments[i].checked) {
                                    this.attachments.splice(i--, 1)
                                }
                                if (_this.attachments[i]) _this.attachments[i].checked = false
                            }
                            this.checkall = false
                            this.$message.success(res.message)
                            this.$forceUpdate()
                        } else {
                            this.$alert(res.message, '操作提示', { type: 'error' })
                        }
                    })
                })
            } else {
                this.checkall = false
                for (let i = 0; i < this.attachments.length; i++) {
                    this.attachments[i].checked = false
                }
            }
            this.$forceUpdate()
        },
        handleUploadChange(file, fileList) {
            // 不允许上传同名文件
            if (!this.attachments) {
                this.attachments = []
            }
            for (var j = 0; j < this.attachments.length; j++) {
                if (file.name === this.attachments[j].fileName && (this.attachments[j].fileType === this.attachsType || (!this.sameNameBodyfile && this.attachments[j].fileType === 'BODY'))) {
                    this.$message.error('文件“' + file.name + '”已存在，不允许上传命名文件。')
                    fileList.remove(file)
                    return
                }
            }
            if (this.accept && this.accept !== '*.*') {
                // accept包含"/"，例：image/jpeg等，格式比较多，不再检测扩展名是否匹配
                if (this.accept.indexOf('/') === -1) {
                    let extName = ''
                    if (file.name.indexOf('.') !== -1) {
                        extName = file.name.substring(file.name.lastIndexOf('.'))
                    }

                    if (extName === '' || (this.accept + ',').indexOf(extName + ',') === -1) {
                        this.$message({ message: '不支持的文件格式！', type: 'warning' })
                        fileList.remove(file)
                        return
                    }
                }
            }

            this.uploadAttach = fileList

            const attach = {}
            attach.fileName = file.name
            attach.fileSize = formatFileSize(file.size)
            attach.fileType = this.attachsType
            attach.uploadBy = this.loginUser.personName
            attach.uploadTime = '待上传'
            attach.file = file
            attach.checked = false
            file.progress = 0
            this.attachments.push(attach)
            this.checkall = false
            this.$forceUpdate()
            this.$emit('change', attach, 1)
            if (this.autoUpload) {
                let scope = null
                if (this.$vnode.context.wfInstance) {
                    scope = this.$vnode.context
                } else if (this.$vnode.context.$parent.moduleInfo) {
                    scope = this.$vnode.context.$parent
                    scope.wfInstance = { module: scope.moduleCode, bodyDocId: '' }
                } else if (this.$vnode.context.$parent.$vnode.context.moduleInfo) {
                    scope = this.$vnode.context.$parent.$vnode.context
                    scope.wfInstance = { module: scope.moduleCode, bodyDocId: '' }
                }

                if (scope) {
                    this.uploadWflowAttach(scope)
                }
            }
        },
        uploadWflowAttach($scope, actionType) {
            const _this = this
            return new Promise(async (resole) => {
                const uploadAttach = []

                if ($scope.doNextAttachList) {
                    $scope.doNextAttachList.forEach((doNextAttach) => {
                        if (doNextAttach.file && doNextAttach.file.progress === 0) {
                            this.attachments.push(doNextAttach)
                        }
                    })
                }
                const forwardAttachs = []
                if (!_this.attachments) {
                    _this.attachments = $scope.attachments
                }
                _this.attachments.forEach((attach, index) => {
                    if (attach.file != null && !attach.file.complete && attach.uploadIndex === undefined) {
                        if (attach.fileType === this.attachsType || attach.uploadType === 'formfile' || attach.uploadType === 'DONEXT' || attach.uploadType === 'FORMFILECGY') {
                            attach.file.message = null
                            attach.file.fileType = attach.fileType || this.attachsType
                            attach.uploadIndex = index
                            uploadAttach.push(attach)
                        }
                    } else if (attach.forward) {
                        forwardAttachs.push(attach)
                    }
                })

                if (forwardAttachs.length > 0) {
                    $scope.wfInstance.passenger.forwardAttachs = forwardAttachs
                }

                // 上传文件
                async function uploadAttachFile(attach) {
                    const file = attach.file
                    const config = {
                        onUploadProgress: (progressEvent) => {
                            const complete = ((progressEvent.loaded / progressEvent.total) * 100) | 0
                            _this.$set(file, 'progress', complete)
                            _this.$set(attach, 'file', file)
                            _this.$forceUpdate()
                        }
                    }
                    let module = $scope.wfInstance.module

                    if (module === undefined) {
                        module = $scope.moduleCode || _this.wfAttachUrl.split('/')[1]
                    }

                    var reqData = { module: module, busiDataId: $scope.vo.id, attachsName: encodeURI(file.name), attachsType: file.fileType, attachsSize: file.size, bodyDocId: $scope.wfInstance.bodyDocId, clientType: 'uploader', uploadIndex: attach.uploadIndex || 0 }
                    if (attach.uploadType === 'DONEXT' || attach.uploadType === 'formfile' || attach.uploadType === 'FORMFILECGY') {
                        // 代办佐证材料
                        reqData.uploadBy = attach.uploadBy
                        reqData.ideaAttacMultiple = attach.passenger.ideaAttacMultiple
                    }

                    let uploadUrl = _this.wfAttachUrl + '/upload'
                    if (_this.$vnode.context.moduleInfo && _this.$vnode.context.moduleInfo.uploadAttach) {
                        uploadUrl = _this.$vnode.context.moduleInfo.uploadAttach
                    }
                    const uploadRst = await _this.$wfEngine.upload(_this, uploadUrl, file.raw, reqData, config)

                    return uploadRst
                }

                // 先上传正文
                if ($scope.bodyfile && $scope.bodyfile.file !== undefined && $scope.bodyfile.file !== null && $scope.bodyfile.file.progress === 0) {
                    const bodyfile = $scope.bodyfile
                    bodyfile.file.message = null
                    bodyfile.file.fileType = bodyfile.fileType || this.attachsType
                    const resp = await uploadAttachFile(bodyfile)

                    if (resp.code === 'success') {
                        bodyfile.file.complete = true

                        let uploadBodyfile = null
                        resp.body.uploadAttachList.forEach((attach) => {
                            $scope.attachments.push(attach)

                            if (attach.fileName.indexOf('.pdf') || attach.fileName.indexOf('.ofd')) {
                                // $scope.$set($scope, 'bodyfile', attach),浏览器刷新
                                uploadBodyfile = attach
                                $scope.bodyfile = attach

                                if (typeof $scope.vo.flBodyFilename !== 'undefined') {
                                    $scope.vo.flBodyFilename = attach.fileName
                                }
                            }
                        })

                        if (resp.body.uploadAttachList.length === 1 && resp.body.uploadAttachList[0].fileName.indexOf('.doc') === -1) {
                            // 上传的正文不是doc格式，禁用编辑正文按钮
                            $scope.commandBar.forEach((btn) => {
                                if (btn.btnCode === 'btnOpenWordClick') {
                                    $scope.$set(btn, 'btnShow', false)
                                }
                            })
                        }

                        // 判断当前上传文件以决定 haveDoc 状态
                        const fileName = bodyfile.file.name
                        const extName = fileName.substring(fileName.lastIndexOf('.')).toLowerCase()

                        let docEditMode = ''
                        if (this.$vnode.context.wfInstance.passenger.docEditMode) {
                            // 当前模式获取
                            docEditMode = this.$vnode.context.wfInstance.passenger.docEditMode
                        }

                        if (fileName.indexOf('SignedFile_' + $scope.wfInstance.bodyDocId) === 0) {
                            $scope.wfInstance.haveDoc = 2
                            $scope.vo.signedFileName = 'SignedFile_' + $scope.wfInstance.bodyDocId + extName
                        } else if (fileName.indexOf('RedTitle_' + this.$vnode.context.wfInstance.bodyDocId) === 0) {
                            $scope.wfInstance.haveDoc = 2
                        } else if (docEditMode === 'RedTitle') {
                            // 红头模式默认上传 红头文件
                            $scope.wfInstance.haveDoc = 2
                        } else if (docEditMode === 'NoTitle') {
                            // 无红头模式 上传 pdf 的话 默认为红头文件  其他则认为无红头文件 （doc，docx）
                            if (extName === '.pdf' || extName === '.ofd') {
                                $scope.wfInstance.haveDoc = 2
                            } else {
                                $scope.wfInstance.haveDoc = 1
                            }
                        } else {
                            $scope.wfInstance.haveDoc = 2
                        }
                        localStorage.setItem('activeName', 1)

                        if (uploadBodyfile.originalName.indexOf($scope.wfInstance.bodyDocId) === -1 && uploadBodyfile.fileName.indexOf('SignedFile_') === -1) {
                            $scope.wfInstance.bodyDocId = uploadBodyfile.originalName.split('\.')[0]
                        }

                        if (typeof $scope.vo.flBodyFilename !== 'undefined' && ($scope.vo.flBodyFilename === null || $scope.vo.flBodyFilename === '')) {
                            $scope.vo.flBodyFilename = bodyfile.fileName
                        }

                        if (bodyfile.fileName.indexOf('.doc') === -1 && $scope.commandBar) {
                            $scope.commandBar.forEach((btn) => {
                                if (btn.btnCode === 'btnOpenWordClick' || btn.btnCode === 'btnModifyFlTypeClick') {
                                    btn.btnShow = false
                                }
                            })
                        }

                        if (uploadAttach.length === 0) resole({ code: 'success', message: '文件正文上传成功！' })
                    } else {
                        bodyfile.file.status = 'failure'
                        bodyfile.file.message = resp.message
                        if (uploadAttach.length === 0) resole(resp)
                    }
                }

                if (uploadAttach.length === 0) {
                    if (this.isRequired === 1 && !this.hasAttachment && (!actionType || actionType.indexOf('Save') === '-1')) {
                        // this.$alert('请选择需要上传的附件！', '操作提示', { type: 'warning' })
                        // resole({ code: 'failure', message: '没有选择需要上传的附件' })
                        resole({ code: 'failure', message: '请选择需要上传的附件！' })
                    } else {
                        resole({ code: 'success', message: '没有待上传附件' })
                    }
                } else {
                    // 上传附件
                    uploadAttach.forEach(async (attach, index) => {
                        const uploadRst = await uploadAttachFile(attach)
                        const file = attach.file
                        if (uploadRst.code === 'success') {
                            file.complete = true
                            // 检查是否全部上传成功
                            var complete = true
                            if (uploadRst.body.uploadAttachList.length > 0) {
                                _this.attachments.forEach((iattach, iindex) => {
                                    if (file === iattach.file) {
                                        const attachments = $scope.attachments || $scope.vo.passenger.attachments || this.attachments
                                        if (uploadRst.body.uploadAttachList.length === 2) {
                                            attachments.splice(iindex, 1, uploadRst.body.uploadAttachList[0], uploadRst.body.uploadAttachList[1])
                                        } else {
                                            attachments.splice(iindex, 1, uploadRst.body.uploadAttachList[0])
                                        }

                                        if (iattach.fileType === 'DONEXT') {
                                            $scope.$set($scope, 'doNextAttach', uploadRst.body.uploadAttachList[0])
                                        }
                                    }
                                    if (iattach.fileType === this.attachsType && iattach.file && iattach.file.complete !== true) {
                                        complete = false
                                    }
                                })
                            }
                            if (complete) {
                                resole({ code: 'success', message: '附件全部上传成功' })
                                this.$forceUpdate()
                            }
                        } else {
                            file.status = 'failure'
                            file.message = uploadRst.message
                            resole(uploadRst)
                            this.$forceUpdate()
                        }
                    })
                }
            })
        },
        handleUploadError(err, file, fileList) {
            // this.uploading = false
            this.$message({
                showClose: true,
                message: err.message,
                type: 'error',
                dangerouslyUseHTMLString: true
            })
        },
        handleFileDownload(downType) {
            let attachIds = ''
            for (let i = 0; i < this.attachments.length; i++) {
                var attach = this.attachments[i]

                if (attach.checked || (downType === 'all' && attach.file === undefined)) {
                    if (attach.file != null) {
                        this.$alert('未上传的本地文件不支持另存！', '操作提示', { type: 'error' })
                        return
                    } else {
                        attachIds += ',' + attach.id
                    }
                }
            }

            if (attachIds !== '') {
                attachIds = attachIds.substring(1)
                let downUrl = process.env.VUE_APP_BASE_API + '/' + this.wfAttachUrl + '/downloadById?inline=false&attachIds=' + attachIds
                if (this.batchSaveNamefield !== '' && attachIds.split(',').length > 1) {
                    if (this.vo[this.batchSaveNamefield] !== undefined) {
                        this.batchSaveNamefield = this.vo[this.batchSaveNamefield]
                    }
                    if (this.batchSaveNamefield.length > 85) {
                        if (this.batchSaveNamefield.indexOf('.') !== -1) {
                            this.batchSaveNamefield = this.batchSaveNamefield.substring(0, 80) + '…' + this.batchSaveNamefield.substring(this.batchSaveNamefield.lastIndexOf('.'))
                        } else {
                            this.batchSaveNamefield = this.batchSaveNamefield.substring(0, 80) + '….zip'
                        }
                    }
                    downUrl += '&saveAs=' + encodeURI(this.batchSaveNamefield)
                }
                downUrl += '&httpPort=' + location.port
                window.open(downUrl)
            } else if (downType === 'all') {
                this.$alert('没有可下载的附件。', '操作提示', { type: 'warning' })
            } else {
                this.$alert('请选择需要另存的附件。', '操作提示', { type: 'warning' })
            }
        },
        handleOneFileDownload(row) {
            let downUrl = process.env.VUE_APP_BASE_API + '/' + this.wfAttachUrl + '/downloadById?inline=false&attachIds=' + row.id
            downUrl += '&saveAs=' + encodeURI(row.fileName)
            downUrl += '&httpPort=' + location.port
            window.open(downUrl)
        },
        handleOpenEditor(attach) {
            this.$bus.emit('btnEditAttachClick', attach, this.onlineEditor)
        },
        // 返回图片路径
        imgUrl(item) {
            // 文件类型
            var extension = item.oriangialName || item.fileName
            extension = extension.substring(extension.lastIndexOf('.'))
            if (extension === '.doc' || extension === '.docx') {
                return 'images/w-imgs/email/word.png'
            }
            if (extension === '.ppt' || extension === '.pptx') {
                return 'images/w-imgs/email/ppt.png'
            }
            if (extension === '.xls' || extension === '.xlsx') {
                return 'images/w-imgs/email/excel.png'
            }
            if (extension === '.pdf') {
                return 'images/w-imgs/email/pdf.png'
            }
            if (extension === '.ofd') {
                return 'images/w-imgs/email/ofd.png'
            }
            if (extension === '.txt') {
                return 'images/w-imgs/email/txt.png'
            } else if (extension === '.audio' || extension === '.amr' || extension === '.mp3' || extension === '.wav') {
                return 'images/w-imgs/email/audio.png'
            } else if (extension === '.video' || extension === '.mp4' || extension === '.mov') {
                return 'images/w-imgs/email/video.png'
            } else if (extension === '.zip' || extension === '.rar') {
                return 'images/w-imgs/email/zip.png'
            } else if (extension === '.image' || extension === '.mp4' || extension === '.jpg' || extension === '.jpeg' || extension === '.png' || extension === '.gif' || extension === '.bmp' || extension === '.svg') {
                return 'images/w-imgs/email/picture.png'
            } else if (extension === ' ') {
                return 'images/w-imgs/email/none.png'
            } else {
                return 'images/w-imgs/email/other.png'
            }
        }
    }
}
</script>

<style scoped lang="scss">
@import '~@/wapp/common/styles/variables.module.scss';

.el-form {
    margin-top: 20px;

    .svg-icon {
        margin: 0 5px;
    }

    .el-button {
        padding: 7px 5px;
    }

    .el-button:active {
        color: #606266;
    }

    .el-button + .el-button {
        margin-left: 0px;
    }

    .el-link {
        line-height: 20px;
        color: $light-blue;
    }

    .is-disabled {
        color: #c4c5c7 !important;
    }

    .fileHovering {
        background: rgb(165, 196, 93);
    }

    .fileHovering table {
        opacity: 0.5;
    }

    /deep/ .attach-name {
        max-width: 100%;

        span {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }
}

.attach-row {
    padding-top: 5px;
    padding-bottom: 5px;
    line-height: 21px;
}

.no-attachments {
    height: 50px;
    line-height: 20px;
}

.drag-handler {
    cursor: move;
}

/deep/ .atach-draggable .sortable-chosen {
    background: #f5f7fa;
}

/deep/ .el-progress-bar {
    padding-right: 40px !important;
    margin-right: -47px !important;
}

/deep/ .el-progress__text {
    float: right;
}

.attach-row:last-child {
    border-bottom: 0px !important;
}

.docform-attach-container {
    padding: 20px;
    margin: 0px !important;
    background-color: #fff;
    height: calc(100vh - 70px);
}

.attachment-sidebar {
    .sidebar-area {
        border-bottom: solid 1px #eeeeee;

        .sidebar-area-title {
            font-weight: 600;
            line-height: 24px;
            padding: 10px;

            .el-button--primary {
                width: 6px;
                padding: 0px;
                margin-right: 6px;
                margin-top: 5px;
                border-radius: 1px;
                height: 14px;
                cursor: default;
                vertical-align: top;
                display: inline-block;
            }

            div {
                display: inline-block;
                vertical-align: top;
            }
        }

        .sidebar-area-content {
            padding-left: 20px;
            padding-right: 10px;
            padding-bottom: 10px;

            .attach-row {
                border-bottom: #f3f3f3 solid 1px;

                .attach-name {
                    margin-top: -3px;
                    width: 100%;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 2;
                }
            }
        }
    }

    .sidebar-area:last-child {
        border-bottom: 0px;
    }
}

.tb-row-attach-container {
    .el-button--mini {
        font-size: 12px;
        margin-right: 6px;
    }
}
.drag-upload {
    display: flex;
    height: 36px;
    /deep/.el-upload {
        width: 100% !important;
        height: 100% !important;
    }
    /deep/.el-upload-dragger {
        width: 100% !important;
        height: 100% !important;
        .drag-upload-box {
            height: 100%;
            background: #f9fbff;
        }
    }
}
.upload-view {
    .up-btn {
        text-align: end;
        .down {
            font-size: 16px;
            margin-right: 24px;
            color: #999999;
        }
    }

    .upload-box {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .upload-box-left {
            flex: 1;
            width: 40%;
            .upload-label {
                display: flex;
                align-items: center;
                .label-l {
                    width: 20px;
                    height: 24px;
                    margin-left: 6px;
                    img {
                        width: 100%;
                        height: 100%;
                    }
                }
                .label-r {
                    font-size: 14px;
                    color: #333333;
                    margin-left: 10px;
                    flex: 1;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
            }
        }
        .upload-box-right {
            display: flex;
            align-items: center;
            .up-text {
                font-size: 12px;
                color: #999999;
            }
            .up-person {
                text-align: end;
                margin-right: 60px;
                margin-left: 15px;
                .upload-name {
                    margin-right: 15px;
                }
            }
        }
    }
}
@media (max-width: 1740px) {
    .up-person {
        .upload-name {
            margin-right: 5px !important;
        }
    }
}
</style>
